import { html } from 'lit';
import type { OneUxCardElement } from '../OneUxCardElement.js';
import type { SlotTemplateResult } from '../types.js';
import { toSlotTemplateResult } from '../toSlotTemplateResult.js';
export function TitleFragment(this: OneUxCardElement): SlotTemplateResult {
  const template = html`
    <div class="remaining-space card-title">
      <slot name="title" part="title">${this.label}</slot>
    </div>
  `;
  return toSlotTemplateResult(template, true);
}